export const handleResetSearch = (setFilteredResults, setSearchInput) => {
  setFilteredResults([]);
  setSearchInput('');
};
